import Box from "@mui/material/Box";
import Button from "@mui/material/Button"; // MUI ICON COMPONENTS
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box"; // ==============================================================
import { styled } from "@mui/material";

// ==============================================================

export const DisableButton = styled(Button)(({}) => ({
  borderRadius: 5,
  fontSize: 10,
  backgroundColor: "white",
  borderWidth: 2,
  borderStyle: "solid",
  borderColor: "#27C454", //TODO need to get from primary
}));

export const EnableButton = styled(Button)(({}) => ({
  borderRadius: 5,
  fontSize: 10,
  backgroundColor: "light",
}));

const ProductAttributes = ({ names, values, onClick }) => {
  const [selection, setSelection] = useState({});
  const handleClick = (name, value) => () => {
    let newSelection = { ...selection };
    newSelection[name] = value;
    setSelection(newSelection);
    onClick(newSelection);
  };
  const handleCancleClick = (name) => () => {
    let newSelection = { ...selection };
    newSelection[name] = undefined;
    setSelection(newSelection);
    onClick(newSelection);
  };
  return (
    <>
      {names.map((name) => {
        return (
          <>
            {/* DESKTOP */}
            <Box display={{ xs: "none", md: "block" }}>
              <FlexBox flexDirection="row" gap="15px">
                <Typography color="dark.dark3">
                  <SalifyFallback.Label path="Brand" default={name} />
                </Typography>
                {values[name] &&
                  values[name].map((val) => {
                    return (
                      <>
                        {selection[name] === val && (
                          <DisableButton variant="contained" onClick={handleCancleClick(name)}>
                            <span>{val}</span>
                          </DisableButton>
                        )}

                        {selection[name] !== val && (
                          <EnableButton variant="contained" onClick={handleClick(name, val)}>
                            <span>{val}</span>
                          </EnableButton>
                        )}
                      </>
                    );
                  })}
              </FlexBox>
            </Box>
            {/* MOBILE */}
            <Box flex="auto" display={{ xs: "block", md: "none" }}>
              <FlexBox flexDirection="row" gap="15px">
                <Typography color="dark.dark3">
                  <SalifyFallback.Label path="Brand" default={name} />
                </Typography>
                {values[name] &&
                  values[name].map((val) => {
                    return (
                      <>
                        {selection[name] === val && (
                          <DisableButton onClick={handleCancleClick(name)}>
                            <span>{val}</span>
                          </DisableButton>
                        )}

                        {selection[name] !== val && (
                          <EnableButton onClick={handleClick(name, val)}>
                            <span>{val}</span>
                          </EnableButton>
                        )}
                      </>
                    );
                  })}
              </FlexBox>
            </Box>
          </>
        );
      })}
    </>
  );
};

export default ProductAttributes;
